import { Component, signal } from '@angular/core';
import { ImageCheckComponent } from './image-check/image-check.component';
import { ImageSyncComponent } from './image-sync/image-sync.component';

/**
 * Tab shell component for the Images page.
 * Contains two tabs: Image Check (existing) and Image Sync (new).
 */
@Component({
  selector: 'app-images',
  standalone: true,
  imports: [ImageCheckComponent, ImageSyncComponent],
  templateUrl: './images.component.html',
  styleUrls: ['./images.component.scss'],
})
export class ImagesComponent {
  readonly activeTab = signal<'check' | 'sync'>('check');

  setActiveTab(tab: 'check' | 'sync'): void {
    this.activeTab.set(tab);
  }
}
